<style lang="less" scoped>
// @import "../../assets/css/news.less";
@padding: 0.9375rem;

li {
  list-style: none;
}
.newDatas {
  padding: 0 10px;
  h3 {
    text-align: center;
    font-size: 14px;
    color: #333;
    padding-top: 10px;
    background: #fff;
  }
  li {
    padding: @padding;
    margin-bottom: 10px;
    background: #fff;

    h2 {
      color: #333;
      font-weight: 550;
      font-size: 12px;
      cursor: pointer;
      display: flex;
      margin-bottom: 5px;
      justify-content: space-between;

      &:hover {
        color: red;
      }
    }
    .desc {
      line-height: 20px;
      color: #6d6d6d;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      /* 设置文本超出部分省略 */
      text-overflow: ellipsis;
      font-size: 10px;
    }
    .date {
      font-weight: normal;
      font-size: 11px;
      color: #6d6d6d;
    }
    &:last-child {
      border-bottom: none !important;
      margin-bottom: 0 !important;
    }
  }
}
/deep/.desc p span {
  color: #6d6d6d !important;
}
.newImages {
  width: 100%;
}
.seeMoreNews {
  text-align: center;
  margin-bottom: 10px;

  a {
    text-align: center;
    width: 80px;
    height: 30px !important;
    border-radius: 5px;
    display: inline-block;
    font-size: 12px;
    background: #0f36d8f0;
    color: #fff;
    line-height: 30px !important;
  }
}
</style>
<template>
  <div class="contents">
    <!-- 这是一段英文新闻描述 -->
    <div class="quote">
      <div class="newDatas">
        <h3>{{ $t("header.home15") }}</h3>
        <li v-for="(item, index) in lists" :key="index">
          <img class="newImages" :src="item.imgUrl" @click="dataDetail(item)" />
          <h2 class="desc" @click="dataDetail(item)">
            <p v-if="lang != 'en'">
              <span></span>
              {{ item.titleZh }}
            </p>
            <p v-else>
              <span></span>
              {{ item.titleEn }}
            </p>
          </h2>
          <p v-if="item.identifier" class="links">
            <a
              class="date"
              :href="'https://cstr.cn/' + item.identifier"
              target="_blank"
              :title="$t('newTip.newTip1')"
            >
              <img
                style="width: 1.66667rem"
                class="link"
                src="@/assets/images/nav.png"
              />{{ "CSTR:" + item.identifier }}</a
            >
          </p>
          <p v-if="item.datetime" class="date">
            {{ item.datetime.substring(0, 10) }}
          </p>

          <!-- <p class="desc" v-html="item.content"></p> -->
        </li>
        <p class="seeMoreNews">
          <a @click="moreNewsData">{{ $t("diss.diss17") }}</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  data() {
    return {
      loading: false,
      lang: "",
      page: 1,
      name: "",
      sortByData: "all",
      size: 20,
      dataType: "",
      total: 0,
      lists: [],
    };
  },
  mounted() {},
  created() {
    this.lang = this.$cookie.get("lang");
    this.getNewData();
  },
  methods: {
    // 获取新闻列表
    getNewData() {
      let params = {
        page: this.page,
        size: this.size,
      };
      this.$api.getNewData(params).then((res) => {
        if (res.status == 200) {
          this.loading = false;
          this.lists = res.data.items.slice(0, 2);
          this.total = res.data.total;
        } else if (res.data.code == 500) {
          this.loading = false;
          this.$Notice.warning(res.data.message);
        }
      });
    },
    dataDetail(item) {
      var id;
      if (item.oid) {
        id = item.oid;
      } else {
        id = item.id;
      }
      var link = "/news/detail?id=" + id;
      window.open(link, "_blank");

      this.reload();
    },
    moreNewsData() {
      var link = "/news/lists";
      window.open(link, "_blank");
    },
  },
};
</script>